import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { proxy, useSnapshot } from 'valtio';
import { usePrevious } from '@hooks/usePrevious';

export const RouterHistory = proxy<{
  hasNavigated: boolean;
}>({
  hasNavigated: false,
});

export function useSyncRouterHistory() {
  const { asPath } = useRouter();
  const previousPath = usePrevious(asPath);
  useEffect(() => {
    if (previousPath && previousPath !== asPath) {
      RouterHistory.hasNavigated = true;
    }
  }, [asPath, previousPath]);
}

export function useRouterHistory() {
  return useSnapshot(RouterHistory);
}
